module.exports = __webpack_public_path__ + "img/sa701lttjg.c765a4e6.svg";